import { useEffect, useRef } from 'react';
import { motion } from 'motion/react';
import { useTranslation } from 'src/lib/i18n/useTranslation';
import Isolate from 'src/lib/common/ui/isolate';
import WheelLoader from 'src/assets/inline-svg/graphics/wheel-loader.svg?react';
import styles from './ResultsLoadingScreen.module.scss';

interface ResultsLoadingScreenProps {
  isolate?: boolean,
}

export const ResultsLoadingScreen = ({ isolate = false }: ResultsLoadingScreenProps) => {
  const { t } = useTranslation();
  const loaderRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const isolator = loaderRef.current
      ? new Isolate(loaderRef.current)
      : null;

    if (isolator) {
      if (isolate) {
        isolator.activate();
      } else {
        isolator.deactivate();
      }
    }

    return () => {
      isolator?.deactivate();
    };
  }, [isolate]);

  useEffect(() => {
    const ref = loaderRef.current;
    if(ref) {
      ref.focus();
    }
  }, []);

  return (
    <motion.div ref={ loaderRef } tabIndex={ -1 } className={ styles.container } data-isolate={ isolate ? 'true' : 'false' } initial={{  opacity: 0 }} animate={{  opacity: 1 }} exit={{  opacity: 0 }} transition={{ duration: 0.4, delay: 0.2 }}>
      <div className={ styles.containerInner }>

        <div className={ styles.loader }>
          <div className={ styles.loaderGraphic }>
            <WheelLoader />
            </div>
          <div className={ styles.loaderText } role='alert'>
            { t('results_loading_title') }…
          </div>
        </div>

      </div>
    </motion.div>
  );
};
